import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  Button,
  Dialog,
  DialogContent,
  Stack,
  Typography,
} from "@mui/material";
import { TokenSelect } from "modules/bridge/components/TokenSelect";
import CloseIcon from "@mui/icons-material/Close";
import { Address } from "viem";

interface Props {
  open: boolean;
  onToggleTokenModal: () => void;
  onTokenSelect: (address: Address, chainId: number) => void;
  logoURI?: string;
  name?: string;
  symbol?: string;
}

export const TokenDialog = ({
  open,
  onToggleTokenModal,
  onTokenSelect,
  logoURI,
  name,
  symbol,
}: Props) => {
  return (
    <>
      <Button
        onClick={onToggleTokenModal}
        variant="outlined"
        color="secondary"
        sx={{
          justifyContent: "space-between",
          padding: 3,
          minWidth: "160px",
          height: 44,
          borderColor: "grey.200",
          cursor: "pointer",
        }}
      >
        <Stack direction="row" gap={2}>
          {logoURI ? (
            <img width="20px" height="20px" src={logoURI} alt={name} />
          ) : null}
          <Typography variant="body1">{symbol}</Typography>
        </Stack>
        <KeyboardArrowDownIcon />
      </Button>
      <Dialog
        open={open}
        onClose={onToggleTokenModal}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 6,
            padding: 7,
            alignItems: "center",
            width: "100%",
            background: "#F9F9F9",
          },
        }}
      >
        <Stack
          onClick={onToggleTokenModal}
          marginLeft="auto"
          direction="row"
          spacing={2}
          component="div"
        >
          <CloseIcon sx={{ width: 20, height: 20, cursor: "pointer" }} />
        </Stack>
        <Typography variant="h3" marginBottom={10}>
          Select token
        </Typography>
        <DialogContent sx={{ width: "100%", padding: 0 }}>
          <Stack spacing={2}>
            <TokenSelect onSelect={onTokenSelect} />
          </Stack>
        </DialogContent>
      </Dialog>
    </>
  );
};
